import { useSelector } from "react-redux";
import Box from "@mui/material/Box";
import ComponentsList from "./ComponentsList";
import ConnectorsList from "./ConnectorsList";
import Preferences from "./Preferences";
import ToolManagement from "./ToolManagement";
import TriggersList from "./TriggersList";
import FlowProperties from "./FlowProperties";
import SessionViewer from "./SessionViewer";
import { TOOLBOX_MENU_ITEM_TYPES, TOOLBOX_MINIFIED_MENU_WIDTH, TOOLBOX_MAXIMIZED_MENU_WIDTH } from "constants/flowDesigner";
import { PORTAL_HEADER_HEIGHT } from "cxfcomponents/portalShell";

const ToolboxDetails = ({ isExpanded }) => {
   const { showToolboxDetails, toolboxSelectedMenuItem } = useSelector((store) => store?.designer?.settings);

   const PANEL_WIDTHS = {
      [TOOLBOX_MENU_ITEM_TYPES.COMPONENTS]: 310,
      [TOOLBOX_MENU_ITEM_TYPES.CONNECTORS]: 315,
      [TOOLBOX_MENU_ITEM_TYPES.TOOL_MANAGEMENT]: 400,
      [TOOLBOX_MENU_ITEM_TYPES.FLOW_PROPERTIES]: 800,
      [TOOLBOX_MENU_ITEM_TYPES.SESSION_VIEWER]: 600,
      [TOOLBOX_MENU_ITEM_TYPES.PREFERENCES]: 320,
      [TOOLBOX_MENU_ITEM_TYPES.TRIGGERS]: 315
   };

   const renderBody = () => {
      switch (toolboxSelectedMenuItem) {
         case TOOLBOX_MENU_ITEM_TYPES.COMPONENTS:
            return <ComponentsList />;
         case TOOLBOX_MENU_ITEM_TYPES.CONNECTORS:
            return <ConnectorsList />;
         case TOOLBOX_MENU_ITEM_TYPES.TOOL_MANAGEMENT:
            return <ToolManagement />;
         case TOOLBOX_MENU_ITEM_TYPES.FLOW_PROPERTIES:
            return <FlowProperties />;
         case TOOLBOX_MENU_ITEM_TYPES.SESSION_VIEWER:
            return <SessionViewer />;
         case TOOLBOX_MENU_ITEM_TYPES.PREFERENCES:
            return <Preferences />;
         case TOOLBOX_MENU_ITEM_TYPES.TRIGGERS:
            return <TriggersList />;
         default:
            return <ComponentsList />;
      }
   };

   if (!showToolboxDetails) return null;

   const drawer = (
      <Box
         sx={{
            position: "fixed",
            top: PORTAL_HEADER_HEIGHT,
            left: isExpanded ? TOOLBOX_MINIFIED_MENU_WIDTH : TOOLBOX_MAXIMIZED_MENU_WIDTH,
            width: PANEL_WIDTHS[toolboxSelectedMenuItem] || 340,
            maxHeight: `calc(100vh - ${PORTAL_HEADER_HEIGHT}px)`,
            height: [TOOLBOX_MENU_ITEM_TYPES.FLOW_PROPERTIES, TOOLBOX_MENU_ITEM_TYPES.SESSION_VIEWER].includes(toolboxSelectedMenuItem) ? `calc(100vh - ${PORTAL_HEADER_HEIGHT}px)` : "auto",
            overflowY: [TOOLBOX_MENU_ITEM_TYPES.FLOW_PROPERTIES, TOOLBOX_MENU_ITEM_TYPES.SESSION_VIEWER].includes(toolboxSelectedMenuItem) ? "hidden" : "auto",
            overflowX: "hidden",
            backgroundColor: "var(--designer-shell-bg)",
            border: "1px solid var(--designer-shell-border)",
            borderLeft: 0,
            borderRadius: "0 0 8px 0",
            boxSizing: "border-box",
            pointerEvents: "auto",
            zIndex: 1300
         }}
      >
         <Box
            py={1}
            sx={{
               width: "100%",
               height: [TOOLBOX_MENU_ITEM_TYPES.FLOW_PROPERTIES, TOOLBOX_MENU_ITEM_TYPES.SESSION_VIEWER].includes(toolboxSelectedMenuItem) ? "100%" : "auto",
               boxSizing: "border-box"
            }}
         >
            {renderBody()}
         </Box>
      </Box>
   );

   return drawer;
};

export default ToolboxDetails;
